var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('transition',{attrs:{"name":"fade"},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('router-view',{key:_vm.$route.params.id})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }